import React, { useState } from "react";
import { useEffect } from "react";

const dataContext = React.createContext();

const { Provider } = dataContext;

const DataProvider = ({ children }) => {
  const [settings, setSettings] = useState(initSettings);
  const [playerOne, setPlayerOne] = useState("");
  const [playerTwo, setPlayerTwo] = useState("");
  useEffect(() => {
  }, []);

  const restoreSettings = () => setSettings(initSettings);

  return <Provider value={{ settings, playerOne, playerTwo,setPlayerOne,setPlayerTwo, setSettings, restoreSettings }}>{children}</Provider>;
};

const initSettings = {
  rounds: 3,
  time: 30,
  handicap: 3,
  recovery: 2,
  speed: 3,
  options: ["rounds", "time", "handicap", "recovery", "speed"],
  icons:["concierge-bell","stopwatch","hand-rock","medkit","running"],
  minValue: [1, 10, 1, 1, 1],
  maxValue: [7, 99, 10, 7, 5],
};

export const GetData = () => React.useContext(dataContext);

export default DataProvider;
